<template>
  <b-row>
    <b-col>
      <b-card>
        <div class="mb-1">
          <i class="ml-2 fa fa-truck fa-lg"></i><span class="h6 ml-2">{{ $t('views.exsborder.list.title') }}</span>
        </div>
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div v-else-if="!isLoading && orders.length < 1">
          {{ $t('views.exsborder.list.noOrders') }}
        </div>
        <table class="table table-sm table-hover table-striped" v-else>
          <tr>
            <th>
              {{ $t('views.exsborder.list.orderStatus') }}
            </th>
            <th>ID</th>
            <th></th>
          </tr>
          <tbody>
          <tr v-for="item in orders" :key="item['@id']">
            <td>
              {{ item.orderStatus.name }}
            </td>
            <td>
              <div v-if="item.idCase">
                <router-link v-if="ableToViewCase" :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
                  {{ getIdLink(item.idCase['@id']) }}
                </router-link>
                <div v-else>{{ getIdLink(item.idCase['@id']) }}</div>
              </div>
              <div v-else></div>
            </td>
            <td>
              <button class="btn btn-link fa fa-search fa-lg float-right" @click="showOrder(item['@id'])"></button>
            </td>
          </tr>
          </tbody>
        </table>
      </b-card>
    </b-col>
    <ShowModal :id-order="selectedOrder"></ShowModal>
  </b-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loader from '@/components/Dashboard/Layout/Loader'
import getId from '@/utils/getIdFromLink'
import { checkPermission } from '@/utils/checkRoles'
import addParamsToQuery from '@/utils/addParamsToQuery'
import ShowModal from '@/components/Dashboard/Views/BusinessBundle/exsborder/modals/ShowModal'

export default {
  name: 'ClientOrders',
  components: {
    Loader,
    ShowModal
  },

  data () {
    return {
      selectedOrder: null
    }
  },

  computed: {
    ...mapGetters({
      orders: 'clientAgreements/getOrders',
      isLoading: 'clientAgreements/getIsLoadingOrders',
      View: 'clientAgreements/getOrdersView'
    }),
    ableToViewOrder () {
      return checkPermission('orders', 'EXSBOrderShow')
    },
    ableToViewCase () {
      return checkPermission('cases', 'EXCMCaseShow')
    }
  },

  created () {
    this.fetchOrders()
  },

  methods: {
    showOrder (id) {
      this.selectedOrder = id
      this.toggleModal()
    },
    fetchOrders () {
      let link = addParamsToQuery('e_x_s_b_orders', {
        orderStatus: [1, 2, 3, 4]
      })
      this.getPage(link)
    },
    getIdLink (link) {
      return getId(link)
    },
    getOrderStatusId (order) {
      return parseInt(getId(order.orderStatus['@id']))
    },
    ...mapActions({
      getPage: 'clientAgreements/fetchOrders'
    }),
    ...mapMutations({
      toggleModal: 'exsborder/showModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
